<div class="max-w-[1100px] m-auto">
    <div class="flex flex-col items-center">
        @if (pastDeadline === true) {
        <div class="pastDeadline">
            <p>DEADLINE HAS PASSED</p>
            <p>
                The deadline for Polk Education Foundation was
                {{ endDateDisplay }}
            </p>
        </div>
        }
        <div class="self-start">
            <h1 class="flex flex-col items-center">Scholarship Application Instructions</h1>
            <h2>Minimum qualifications to apply</h2>
            <ol type="a">
                <li>
                    <strong>Be a Polk County public or charter high school
                        senior</strong>
                </li>
                <li>
                    <strong>Be on track to graduate and have passed FSA Reading and
                        either the Algebra I EOC or the Geometry EOC</strong>
                    <div class="text-[14px]">
                        The concordant scores below are accepted
                    </div>
                    <div class="mt-[15px] mb-[5px]">
                        <strong>For the Algebra 1 EOC or Geometry EOC, seniors
                            could earn a concordant score of:</strong>
                    </div>
                    <ul>
                        <li class="text-[14px]">
                            PERT Math 97 (only available for students that
                            entered grade nine after the 2018-19 school year)
                        </li>
                        <li class="text-[14px]">ACT Math 16</li>
                        <li class="text-[14px]">SAT Math 420</li>
                        <li class="text-[14px]">PSAT/NMSQT Math 430</li>
                    </ul>
                    <div class="mt-[15px] mb-[5px]">
                        <strong>For the FSA Reading, seniors could earn a
                            concordant score of:</strong>
                    </div>
                    <div class="text-[14px]">
                        For students who entered grade 9 in 2010-11 and beyond:
                    </div>
                    <ul>
                        <li class="text-[14px]">
                            ACT English and Reading subtests 18
                        </li>
                        <li class="text-[14px]">
                            SAT Evidence-Based Reading & Writing 480
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Have your FAFSA Submission Summary</strong>
                    <div class="text-[14px]">
                        Please reach out to your counselor if you have any questions or need assistance in filling out your FAFSA
                    </div>
                    <div class="mt-[15px] mb-[5px]">
                        <strong>Minimum qualifications for East and West Area Adult
                            Students to apply:</strong>
                    </div>
                    <div class="text-[14px]">All adult students can apply</div>
                    <div class="mt-[15px] mb-[5px]">
                        <strong>Minimum qualifications for Ridge and Travis
                            Vocational Students to apply:</strong>
                    </div>
                    <div class="text-[14px]">
                        Any student who has missed less than 20 hours of their
                        program can apply
                    </div>
                </li>
            </ol>
            @if (instructionsRead() === false && pastDeadline === false) {
            <div class="checkbox">
                <mat-checkbox [(ngModel)]="checkboxes[0]">
                    I have read and understand the minimum qualifications to apply
                </mat-checkbox>
            </div>
            }

            <h2>
                If you meet the criteria above, please proceed using the
                following directions
            </h2>
            <ol type="a">
                <li>
                    <strong>Gather all required information before you start</strong>
                    You'll need to have:
                </li>
                <ul>
                    <li class="text-[14px]">
                        Your FAFSA Submission Summary
                    </li>
                    <li class="text-[14px]">
                        Dates of work history (if applicable) and types of
                        community service (if applicable)
                    </li>
                    <li class="text-[14px]">
                        List of scholarships, grants or financial aid you have
                        already been awarded
                    </li>
                    <li class="text-[14px]">
                        A prepared essay that has been spellchecked
                    </li>
                </ul>
                <li>
                    <strong>If you haven't logged in already</strong>,
                    <ul>
                        <li>
                            If you came to this site via Classlink, you are
                            already logged in.
                        </li>
                        <li>
                            <strong>If you are a charter school student</strong>,
                            you must register an account if you haven't done
                            so already, then login using the username you were
                            given and password you created.
                        </li>
                        <li>
                            <strong>If you are a public school student</strong>,
                            you can login using your PCPS username and password.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>To begin a new application</strong>,
                    after you have checked all four checkboxes, click on the
                    <strong>"WORK ON APPLICATION NOW"</strong>
                    button at the bottom of the instruction page.
                </li>
                <li>
                    <strong>After you have done this,</strong>
                    the following applicable information will be pulled from
                    your permanent record and displayed on the initial
                    application page. This cannot be changed.
                    <ul>
                        <li class="text-[14px]">Name</li>
                        <li class="text-[14px]">School</li>
                        <li class="text-[14px]">Weighted GPA</li>
                        <li class="text-[14px]">
                            Passage of FSA Math and FSA Reading
                        </li>
                        <li class="text-[14px]">SAT and/or ACT scores</li>
                        <li class="text-[14px]">Volunteer/Work hours</li>
                    </ul>
                    <div class="mt-[15px] mb-[5px]">
                        The following two items will also be pulled from your
                        permanent records, but you can make changes to update
                        these fields:
                    </div>
                    <ul>
                        <li class="text-[14px]">Mailing Address</li>
                        <li class="text-[14px]">Phone Number</li>
                    </ul>
                    <p class="text-red-700">
                        If any of the "non-changeable" information is incorrect,
                        please contact your counselor and ensure that the
                        information is updated.
                    </p>
                    <p>
                        It is very important your contact information is
                        correct. Please use a personal email address that you
                        check frequently. Email addresses may be used to
                        communicate with you on questions during the application
                        process, or to set an interview.
                    </p>
                </li>
                <li>
                    <strong>To return to an application at a later time</strong>, use the "Login" section to enter your username and
                    password. Then click the "Login" button.
                    <p>
                        If you forget your password, you can use the 'Forgot
                        Password' button in the "Login" section.
                        <br />
                        <strong>NOTE:</strong> The website will not allow you to
                        start a second application once a student ID is in use.
                        You must go back and make changes to the first saved
                        application. If you get the message "Student ID already
                        in use", you must enter as a returning applicant.
                    </p>
                </li>
                <li>
                    <strong>Complete your application</strong>
                    <div class="mt-[15px] mb-[5px]">
                        You should have already reviewed the scholarship list
                        posted on the PEF website to know what you qualify to
                        apply for
                    </div>
                    <ul>
                        <li class="text-[14px]">
                            As you finish each page, hit the "Save & Go To Next
                            Section" button at the bottom of the page to save
                            your work move forward to a new page. (The page will
                            not save unless all on that page is complete)
                        </li>
                        <li class="text-[14px]">
                            Run out of time to complete the whole application?
                            Logout and come back later. Your responses will be
                            saved.
                        </li>
                        <li class="text-[14px]">
                            Read the criteria for each award carefully. If you
                            do not meet ALL the requirements, do not apply for
                            that award. DO NOT check every award without first
                            seeing if you qualify!
                        </li>
                        <li class="text-[14px]">
                            Once you have completed all sections of the
                            application, then and only then should you hit the
                            "Submit Application" button on the final screen of
                            the application. Once you hit "Submit Application",
                            you cannot go back and make any changes to your
                            application. After you submit, you will be brought
                            to a page with all your information on it. You must
                            print this page. After you submit the application,
                            you can log back in to print or view this page, but
                            changes cannot be made.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>
                        If you would like to be considered for any financial need based scholarship,
                        YOU MUST email your FAFSA Student Aid Summary to <span class="text-red-500">pefscholarships@polk-fl.net</span> by {{endDateDisplay}}.
                        Additionally, if any scholarships require you to submit any artwork, video submissions, letters of recommendation, employment verification, etc.
                        YOU MUST also email those documents to <span class="text-red-500">pefscholarships@polk-fl.net</span> by {{endDateDisplay}} to be considered for that specific scholarship.
                        Be sure to include your student id number, and your first and last name in the subject of the email when sending over any required documents.
                    </strong>
                </li>
            </ol>
            <p>
                <strong>A listing of all classes taken in high school will
                    automatically print as part of your application</strong>
            </p>
            @if (instructionsRead() === false && pastDeadline === false) {
            <div class="checkbox">
                <mat-checkbox [(ngModel)]="checkboxes[1]">
                    I have read and understand the scholarship application
                    directions
                </mat-checkbox>
            </div>
            }
            <mat-card class="my-[20px] p-[20px] border border-solid border-sky-300">
                <div class="my-[20px] p-[20px] bg-gray-300">
                    <p>
                        <strong>
                            REMINDER: You must email any scholarship specific required documents
                            including FAFSA Student Aid Summary to
                            <span class="text-red-500">pefscholarships@polk-fl.net</span>
                            by {{endDateDisplay}} to be considered for those scholarships.
                            Be sure to include your student id number,
                            and your first and last name in the subject of the email when sending over any required documents.
                        </strong>
                    </p>
                </div>
                <div class="my-[20px] p-[20px] bg-gray-300">
                    <strong class="text-red-500">Please Note: The application will close on
                        {{ endDateDisplay }}</strong>
                </div>
            </mat-card>
            @if (instructionsRead() === false && pastDeadline === false) {
            <div class="checkbox">
                <mat-checkbox [(ngModel)]="checkboxes[2]">
                    I have read and understand the above requirements concerning
                    what I need to submit to my counselor and when
                </mat-checkbox>
            </div>
            }
            <p><strong>Award announcements and recipient follow-up:</strong></p>
            <p>
                All scholarship recipients will be announced at their high
                school's senior award ceremonies. No letters of regret will be
                sent and no early notifications made unless done by a donor
                (some invite their recipients to club meetings).
            </p>
            <p>
                Recipients will receive letters of congratulations and
                instruction from the Polk Education Foundation (PEF) after all
                senior award ceremonies are complete. They will be given the
                name and address of their scholarship sponsor, and will be
                required to send the sponsor a thank you letter. A copy of that
                note along with a completed "College Information Sheet" (this
                will be enclosed with the award letter) must be submitted to the
                PEF for funds to be disbursed to the school of the students'
                choice. Funds are not disbursed until all requirements are met.
            </p>
            <p>
                It is the student's responsibility to follow up each year, IF
                REQUIRED by the donor, with any information to renew (usually a
                transcript). That requirement would be noted in the award
                package. No reminders are given, students must comply to receive
                further funding.
            </p>
            <p>
                Scholarship funds are held at the Polk Education Foundation for
                students use for up to five years, and then if unused, they are
                returned to the donor fund. Do not wait to request them until
                after you have graduated college / post-secondary training. They
                cannot be used to make student loan payments after you have
                graduated! Please note: Scholarships administered by the PEF are
                paid out only after receipt of funds from a donor. This also
                stands for multiple year awards with annual renewable payments.
            </p>
            <p>
                <strong class="text-red-500">
                    If the student does not attend their high school's senior award ceremony,
                    the donor reserves the right to rescind the scholarship and award to another student.
                </strong>
            </p>
            @if (instructionsRead() === false && pastDeadline === false) {
            <div class="checkbox">
                <mat-checkbox [(ngModel)]="checkboxes[3]">
                    I have read and understand the award announcements and recipient follow-up
                </mat-checkbox>
            </div>
            }
        </div>
        @if (pastDeadline === true) {
        <div class="mt-[30px]">
            SORRY, THE DEADLINE HAS PASSED
        </div>
        }
        @if (invalidForm === true) {
        <div class="summary mt-[30px]">
            <div>
                You must read the instructions and check all the checkboxes to continue
            </div>
        </div>
        }
        @if ((pastDeadline === false || deadlineException() === true) && instructionsRead() === false) {
        <button class="mt-[30px]" mat-raised-button (click)="goToApplication()">
            Work on Application Now
        </button>
        }
        @if (instructionsRead() === true) {
        <button class="mt-[30px]" mat-raised-button (click)="back()">
            Go Back To Previous Page
        </button>
        }
    </div>
</div>